import { useEffect, useState } from 'react'
import type { Language } from '../../models/LandingPage'
import { getAnalyticsConsent, onCookieSettingsOpen, setAnalyticsConsent } from '../../utils/analytics'

type CookieBannerProps = {
  language: Language
}

const cookieCopy = {
  en: {
    title: 'Privacy-first analytics',
    text: 'We use optional analytics to improve ToneSignature.',
    learnMore: 'Learn more',
    reject: 'Reject non-essential cookies',
    accept: 'Accept analytics',
  },
  it: {
    title: 'Analytics e privacy',
    text: 'Usiamo analytics facoltativi per migliorare ToneSignature.',
    learnMore: 'Scopri di più',
    reject: 'Rifiuta i cookie non essenziali',
    accept: 'Accetta analytics',
  },
}

export function CookieBanner({ language }: CookieBannerProps) {
  const [choice, setChoice] = useState(() => getAnalyticsConsent())
  const copy = cookieCopy[language]

  function handleChoice(consent: 'accepted' | 'rejected') {
    setAnalyticsConsent(consent)
    setChoice(consent)
  }

  useEffect(() => onCookieSettingsOpen(() => setChoice(null)), [])

  if (choice) {
    return null
  }

  return <div className="cookie" role="region" aria-label="Cookie consent"><div><b>{copy.title}</b><p>{copy.text} <a href="/cookies">{copy.learnMore}</a></p></div><button className="ghost-cookie" type="button" onClick={()=>handleChoice('rejected')}>{copy.reject}</button><button type="button" onClick={()=>handleChoice('accepted')}>{copy.accept}</button></div>
}
